import NoMarginH4 from '../common/NoMarginH4';
import { DEFAULT_SECTIONS_LIST } from '../types';
import { StylishNewButton } from '../../../DesignSystems/New/StylishNewButton';
import AddIcon from '../../../../assets/images/icon__add.svg';
import { useToggle } from 'react-use';
import StylishNewInput from '../../../DesignSystems/New/StylishNewInput';
import { useSitrepSectionWizardContext } from '../SitrepSectionWizardContext';
import EditIcon from '../../../../assets/images/icon__edit.svg';
import DeleteIcon from '../../../../assets/images/icon__delete.svg';
import React from 'react';

/**
 * First step of the Sitrep Section Wizard. This component displays the default
 * sections for a SITREP, along with the ability to create custom sections.
 */
const SectionTemplates = () => {
  const { sectionName, setSectionName } = useSitrepSectionWizardContext();
  const [isEditingName, setIsEditingName] = useToggle(false);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      setIsEditingName(false);
    } else if (event.key === 'Escape') {
      setSectionName('');
      setIsEditingName(false);
    }
  };

  return (
    <div className="d-flex flex-column gap-3">
      <NoMarginH4>Default</NoMarginH4>
      <div className="d-flex flex-column gap-3 mx-5">
        {DEFAULT_SECTIONS_LIST.map((section) => (
          <h6 key={section} className="m-0">
            {section}
          </h6>
        ))}
      </div>
      <div className="d-flex flex-row justify-content-between">
        <NoMarginH4>Custom</NoMarginH4>
        {!sectionName && (
          <StylishNewButton
            className="dark-background-button"
            onClick={() => setIsEditingName()}
          >
            <img src={AddIcon} alt="" />
          </StylishNewButton>
        )}
      </div>
      {isEditingName && (
        <>
          <div className="d-flex flex-row justify-content-end">
            <StylishNewInput
              autoFocus
              value={sectionName}
              onChange={(e) => setSectionName(e.currentTarget.value)}
              onKeyDown={handleKeyDown}
            />
          </div>
        </>
      )}
      {!isEditingName && sectionName && (
        <div className="d-flex flex-row justify-content-between custom-section-row">
          <h6 className="m-0">{sectionName}</h6>
          <div className="button-container">
            <StylishNewButton
              className="dark-background-button"
              onClick={() => setIsEditingName(true)}
            >
              <img src={EditIcon} alt="" />
            </StylishNewButton>
            <StylishNewButton
              className="dark-background-button"
              onClick={() => setSectionName('')}
            >
              <img src={DeleteIcon} alt="" />
            </StylishNewButton>
          </div>
        </div>
      )}
    </div>
  );
};

export default SectionTemplates;
